import React, { useCallback, useMemo } from 'react';

import DataTable from 'components/DataTableComponent/DataTable';

import { IAddedLanguagesTableProps, ILanguageTableRow } from './AddedLanguagesTable.types';
import { mergeLanguageRows } from './AddedLanguagesTable.utils';
import { useLanguageTableColumns } from './hooks/useLanguageTableColumns';

export const AddedLanguagesTable = ({
  languagesList,
  isLoading,
  selectedLanguage,
  setIsDeleteLngModalOpen,
  setSelectedLanguage,
  setIsManageLngModalOpen,
  editSelectedLanguage
}: IAddedLanguagesTableProps): React.ReactElement => {
  const rowsData = useMemo(
    (): ILanguageTableRow[] => mergeLanguageRows(languagesList),
    [languagesList]
  );

  const handleToggleLanguage = useCallback((currentLanguage: ILanguageTableRow): void => {
    const newEnabledState = !currentLanguage.isEnabled;
    const parsedLanguageData = languagesList.map((languageItem) => {
      const { countryCode, ...restItemData } = languageItem;
      return languageItem.language === currentLanguage.language
        ? { ...restItemData, country: countryCode, isEnabled: newEnabledState }
        : { ...restItemData, country: countryCode };
    });

    setSelectedLanguage({ ...currentLanguage, isEnabled: newEnabledState });
    editSelectedLanguage(parsedLanguageData);
  }, [languagesList, setSelectedLanguage, editSelectedLanguage]);

  const handleEdit = useCallback((row: ILanguageTableRow): void => {
    setIsManageLngModalOpen(true);
    setSelectedLanguage(row);
  }, [setIsManageLngModalOpen, setSelectedLanguage]);

  const handleDelete = useCallback((row: ILanguageTableRow): void => {
    setIsDeleteLngModalOpen(true);
    setSelectedLanguage(row);
  }, [setIsDeleteLngModalOpen, setSelectedLanguage]);

  const { columns } = useLanguageTableColumns({
    selectedLanguage,
    onToggle: handleToggleLanguage,
    onEdit: handleEdit,
    onDelete: handleDelete
  });

  return (
    <div className="rounded-lg overflow-hidden">
      <DataTable
        data={rowsData}
        columns={columns}
        rowIdIdentifier="_id"
        bodyDataTestId="dashLanguagesList"
        isLoading={isLoading}
        bordered={false}
      />
    </div>
  );
};

export default AddedLanguagesTable;
